export class PageEntity {

    public pageSize:number = 10;
    public pageNum:number = 1;
    public total:number = 0;
}